import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-menu"
export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon"]
  static values = {
    open: { type: Boolean, default: false }
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.openValue) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.openValue = true
    this.menuTarget.classList.remove("hidden")
    this.menuTarget.classList.add("animate-slide-in")

    if (this.hasOpenIconTarget && this.hasCloseIconTarget) {
      this.openIconTarget.classList.add("hidden")
      this.closeIconTarget.classList.remove("hidden")
    }

    // Prevent body scroll when mobile menu is open
    document.body.style.overflow = "hidden"
  }

  close() {
    this.openValue = false
    this.menuTarget.classList.add("hidden")
    this.menuTarget.classList.remove("animate-slide-in")

    if (this.hasOpenIconTarget && this.hasCloseIconTarget) {
      this.openIconTarget.classList.remove("hidden")
      this.closeIconTarget.classList.add("hidden")
    }

    // Restore body scroll
    document.body.style.overflow = ""
  }
}
